import { BrowserRouter, Route, Routes, Navigate, HashRouter, Outlet } from "react-router-dom";
import ClippedDrawer from './components/Drawer/Drawer';
import './App.css';
import { AuthProvider } from './context/AuthProvider';
import { useSelector, useDispatch } from 'react-redux';
import LoginPage from './components/LoginPage/LoginPage';
import RequireAuth from "./auth/RequireAuth";

import { Details, Logout, SecurityTwoTone } from "@mui/icons-material";
// import AddUser from '../AddUser/AddUser'
// import EditUser from '../EditUser/EditUser'
import EditHomeBanner from "./components/EditHomeBanner/EditHomeBanner";
// import Career from "./components/Career/Career";
import Investor from "./components/Investor/Investor";
import Media from "./components/Media/Media";
import ContactUs from "./components/ContactUs/ContactUs";
import EditOurBusiness from "./components/EditOurBusiness/EditOurBusiness";
import EditTeamMember from "./components/EditTeamMember/EditTeamMember";
import MeetOurTeam from "./components/MeetOurTeam/MeetOurTeam";
import OurBusiness from "./components/OurBusiness/OurBusiness";
import InvestmentHighlights from "./components/InvestmentHighlights/InvestmentHighlights";
import EditInvestHighlight from "./components/EditInvestHighlight/EditInvestHighlight";
import CompanyDetails from "./components/CompanyDetails/CompanyDetails";
import EditCompanyDetail from "./components/EditCompanyDetail/EditCompanyDetail";
import UpcomingEvents from "./components/UpcomingEvents/UpcomingEvents";
import EditEvent from "./components/EditEvent/EditEvent";
import Gallery from "./components/Gallery/Gallery";
import EditGallery from "./components/EditGallery/EditGallery";
import BranchAddress from "./components/BranchAddress/BranchAddress";
import EditAddress from "./components/EditAddress/EditAddress";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
// import SearchIcon from "@mui/icons-material/Search";
import JobApplicants from "./components/JobApplicants/JobApplicants";
import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';
import JobRoles from "./components/JobRoles/JobRoles";
import ViewApplicants from "./components/ViewApplicants/ViewApplicants";
import AddOurBusiness from "./components/AddOurBusiness/AddOurBusiness";
import AddTeamMember from "./components/AddTeamMember/AddTeamMember";
import AddInvestHighlight from "./components/AddInvestHighlight/AddInvestHighlight";
import AddCompanyDetail from "./components/AddCompanyDetail/AddCompanyDetail";
import AddUpcomingEvent from "./components/AddUpcomingEvent/AddUpcomingEvent";
import AddGallery from "./components/AddGallery/AddGallery";
import AddAddress from "./components/AddAddress/AddAddress";
import Applicant from "./components/Applicant/Applicant";
import ContactsList from "./components/ContactsList/ContactsList";
import PostJob from "./components/PostJob/PostJob";
import ApplicantDetails from "./components/ApplicantDetails/ApplicantDetails";
import EditJob from "./components/EditJob/EditJob";
import InvestorOpportunities from "./components/InvestorOpportunities/InvestorOpportunities";
import AddInvOpportunities from "./components/AddInvOpportunities/AddInvOpportunities";
import EditInvOpportunities from "./components/EditInvOpportunities/EditInvOpportunities";
import EditInvOppo2 from "./components/EditInvOppo2/EditInvOppo2";
import InvRequest from "./components/InvRequest/InvRequest";
import AddFormat from "./components/AddFormat/AddFormat";
import AddPitch from "./components/AddPitch/AddPitch";
import ShortSummary from "./components/ShortSummary/ShortSummary";
import TheMarket from "./components/TheMarket/TheMarket";
import Ourteam from "./components/OurTeam/OurTeam";
import TheBusiness from "./components/TheBusiness/TheBusiness";
import AddMarket from "./components/AddMarket/AddMarket";
import EditMarket from "./components/EditMarket/EditMarket";
import AddBusin from "./components/AddBusiness/AddBusin";
import Editbusi from "./components/Editbusi/Editbusi";
import AddOur from "./components/AddOur/AddOur";
import EditOur from "./components/EditOur/EditOur";
import Document from "./components/Document/Document";
import AddDoc from "./components/AddDoc/AddDoc";
import EditDoc from "./components/EditDoc/EditDoc";
import EditPdf from "./components/EditPdf/EditPdf";
import EditVideo from "./components/EditVideo/EditVideo";
import VideoFor from "./components/VideoFor/VideoFor";
import Interested from "./components/Interested/Interested";
import CreateLink from "./components/CreateLink/CreateLink";
import EditInvestmentBanner from "./components/InvestorOpportunities/EditInvestmentBanner";
import Dashboard from "./components/Dashboard/Dashboard";
import Homepage from "./components/Homepage/Homepage";
import UserTicket from "./components/UserTicket/UserTicket";
import Notifications from "./components/Notifications/Notifications";
import MediaAdd from "./components/MediaAdd/MediaAdd";
import MediaPosts from "./components/MediaPosts/MediaPosts";

function App() {



  return (
    <>

      <HashRouter>

        <Routes>

          <Route exact path='/logout' element={<LoginPage />} />
          <Route exact path='/login' element={<LoginPage />} />
          <Route element={<RequireAuth />}>

            <Route path='/' element={<ClippedDrawer />} >

            <Route path="test" element={<MediaAdd/>} />
              <Route index element={<Dashboard />} />
              <Route path='/dashboard' element={<Dashboard />} />
              <Route path='/leadslist' element={<ContactsList />} />
              {/* <Route path='/role' element={<Roles />} /> */}
              {/* <Route path='/add user' element={<AddUser />} />
          <Route path='/edit user' element={<EditUser />} /> */}
              <Route path='/ticket' element={<UserTicket />} />
              <Route path='/notifications' element={<Notifications />} />
              <Route path='/homepage' element={<Homepage />} />
              <Route path='/homebanner' element={<EditHomeBanner />} />
              <Route path='/ourbusiness' element={<OurBusiness />} />
              <Route path='/addbusiness' element={<AddOurBusiness />} />
              <Route path='/business/:id' element={<EditOurBusiness />} />
              <Route path='/meetourteam' element={<MeetOurTeam />} />
              <Route path='/addteammember' element={<AddTeamMember />} />
              <Route path='/teammember/:id' element={<EditTeamMember />} />
              <Route path='/investor' element={<Investor />} />
              <Route path='/investment' element={<InvestmentHighlights />} />
              <Route path='/addinvestment' element={<AddInvestHighlight />} />
              <Route path='/editinvestment/:id' element={<EditInvestHighlight />} />
              <Route path='/companydetails' element={<CompanyDetails />} />
              <Route path='/adddetail' element={<AddCompanyDetail />} />
              <Route path='/editdetail/:id' element={<EditCompanyDetail />} />
              <Route path='/media' element={<Outlet />} >
              <Route index element={<Media />} />
              <Route path='posts' element={<MediaPosts />} />
              <Route path='create-posts/:id?' element={<MediaAdd />} />
              </Route>
              <Route path='/upcomingevents' element={<UpcomingEvents />} />
              <Route path='/addevent' element={<AddUpcomingEvent />} />
              <Route path='/editevent/:id' element={<EditEvent />} />
              <Route path='/gallery' element={<Gallery />} />
              <Route path='/addgallery' element={<AddGallery />} />
              <Route path='/editgallery/:id' element={<EditGallery />} />
              <Route path='/contact_us' element={<ContactUs />} />
              <Route path='/branchaddress' element={<BranchAddress />} />
              <Route path='/addaddress' element={<AddAddress />} />
              <Route path='/editaddress/:id' element={<EditAddress />} />
              <Route path='/jobapplicants' element={<JobApplicants />} />
              <Route path='/editInvestmentBanner/:id' element={<EditInvestmentBanner />} />

              <Route path='/applicants/:id' element={<Applicant />} />
              <Route path='/jobroles' element={<JobRoles />} />
              <Route path='/postjob' element={<PostJob />} />
              <Route path='/editjob/:id' element={<EditJob />} />
              <Route path='/viewapplicants/:id' element={<ViewApplicants />} />
              <Route path='/applicantdetails/:id' element={<ApplicantDetails />} />
              {/* <Route path='/adduser' element={<AddUser />} /> */}
              {/* <Route path='/edituser' element={<EditUser />} /> */}
              {/* <Route path='/edituser' element={<EditUser />} /> */}


              <Route path='/InvestmentOpp' element={<InvestorOpportunities />} />
              <Route path='/AddInvOppo' element={<AddInvOpportunities />} />

              <Route path='/EditInv2' element={<EditInvOppo2 />} />



              <Route path='/request' element={<InvRequest />} />
              <Route path='/interest' element={<Interested />} />

              <Route path='/formates' element={<AddFormat />} />
              <Route path='/videofor' element={<VideoFor />} />


              <Route path='/EditInvOppo/:invId' element={<Outlet />} >
                <Route index element={<EditInvOpportunities />} />



                <Route path='pitch/:channelId' element={<Outlet />} >
                  <Route index element={<AddPitch />} />

                  <Route path="short-summary" element={<Outlet />} >
                    <Route index element={<ShortSummary />} />
                    <Route path=":summaryId" element={<ShortSummary />} />
                  </Route>


                  <Route path="our-bussiness" element={<Outlet />} >
                    <Route index element={<TheBusiness />} />
                    <Route path="create" element={<AddBusin />} />
                    <Route path=":bussinessId" element={<Editbusi />} />
                  </Route>


                  <Route path="the-market" element={<Outlet />} >
                    <Route index element={<TheMarket />} />
                    <Route path="create" element={<AddMarket />} />
                    <Route path=":marketId" element={<EditMarket />} />
                  </Route>


                  <Route path="our-team" element={<Outlet />} >
                    <Route index element={<Ourteam />} />
                    <Route path="create" element={<AddOur />} />
                    <Route path=":teamId" element={<EditOur />} />
                  </Route>


                  <Route path="doc" element={<Outlet />} >
                    <Route index element={<Document />} />
                    <Route path="create" element={<AddDoc />} />
                    <Route path=":docId" element={<EditDoc />} />
                  </Route>



                </Route>
              </Route>


              {/* <Route path='/summary/:id/:id2/:summaryId' element={<ShortSummary />} />

              <Route path='/market/:id/:id2' element={<TheMarket />} />
              <Route path='/addmarket/:id/:id2' element={<AddMarket />} />
              <Route path='/editmarket/:id/:id2/:id3' element={<EditMarket />} />

              <Route path='/our/:id/:id2' element={<Ourteam />} />
              <Route path='/addour/:id/:id2' element={<AddOur />} />
              <Route path='/editour/:id/:id2/:id3' element={<EditOur />} />

              <Route path='/theBusi/:id/:id2' element={<TheBusiness />} />
              <Route path='/addBusi/:id/:id2' element={<AddBusin />} />
              <Route path='/editBusi/:id/:id2/:id3' element={<Editbusi />} />

              <Route path='/doc/:id/:id2' element={<Document />} />
              <Route path='/adddoc/:id/:id2' element={<AddDoc />} />
              <Route path='/editdoc/:id/:id2/:id3' element={<EditDoc />} /> */}

              <Route path='/editpdf/:id/:id2/:id3' element={<EditPdf />} />
              <Route path='/editVi/:id/:id2/:id3' element={<EditVideo />} />



              <Route path='/createL/:id/:invName' element={<CreateLink />} />
            </Route>


          </Route >

        </Routes >

      </HashRouter >
    </>
  );
}

export default App;